import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Global error handler for removeChild and ResizeObserver errors
const originalError = console.error;
console.error = (...args) => {
  const errorMessage = args[0];
  
  // Suppress removeChild, NotFoundError, and ResizeObserver errors
  if (
    typeof errorMessage === 'string' &&
    (errorMessage.includes('removeChild') ||
     errorMessage.includes('NotFoundError') ||
     errorMessage.includes('The node to be removed is not a child of this node') ||
     errorMessage.includes('ResizeObserver loop'))
  ) {
    // Silently ignore these errors - they're cosmetic and don't affect functionality
    return;
  }
  
  // Log all other errors normally
  originalError.apply(console, args);
};

// Suppress React's error overlay for removeChild and ResizeObserver errors
window.addEventListener('error', (event) => {
  if (
    event.message &&
    (event.message.includes('removeChild') ||
     event.message.includes('NotFoundError') ||
     event.message.includes('The node to be removed is not a child of this node') ||
     event.message.includes('ResizeObserver loop'))
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Suppress unhandledrejection for these errors too
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    event.reason.message &&
    (event.reason.message.includes('removeChild') ||
     event.reason.message.includes('NotFoundError') ||
     event.reason.message.includes('ResizeObserver loop'))
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA (offline assets + Install on Home Screen)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("SW registration failed", err));
  });
}
